import { useCallback, useEffect } from 'react';

import { injectReducer } from '@lumapps/redux/manager';
import { useDispatch, useSelector } from '@lumapps/redux/react';

import { isArticleDialogOpenSelector } from '../ducks/selectors';
import { actions, reducer } from '../ducks/slice';

/** Dynamically inject the articles reducer in case it was not already existing. */
injectReducer('articles', reducer);

export const useArticleDialog = () => {
    const dispatch = useDispatch();
    const isArticleDialogOpen = useSelector(isArticleDialogOpenSelector);

    const openArticleDialog = useCallback(() => {
        dispatch(actions.openDialog());
    }, [dispatch]);
    const closeArticleDialog = useCallback(() => dispatch(actions.closeDialog()), [dispatch]);

    /** Closing the dialog on component unmount */
    useEffect(() => {
        return () => {
            closeArticleDialog();
        };
    }, [closeArticleDialog]);

    return {
        openArticleDialog,
        closeArticleDialog,
        isArticleDialogOpen,
    };
};
